class AtollonEvent extends Event {
  public static readonly INFO_CHANGED: string = 'infoChanged';
  public static readonly FINDER_DETAIL_LOADED: string = 'finderDetailLoaded';
  public static readonly CREATE_CONTEXT_APP: string = 'createContextApp';
  public static readonly CONTACTS_APP_LOADED: string = 'contactsAppLoaded';
  public static readonly INVOICE_APP_LOADED: string = 'invoiceAppLoaded';
  public static readonly ISSUE_APP_LOADED: string = 'issueAppLoaded';
  public static readonly NEW_MESSAGE_CREATING: string = 'newMessageCreating';
  public static readonly NEW_MESSAGE_CREATED: string = 'newMessageCreated';
  public static readonly REPLY_MESSAGE: string = 'replyMessage';
  public static readonly COMMUNICATION_MOBILE_MENU: string = 'communicationMobileMenu';
  public static readonly TEAM_INBOX_UPDATED: string = 'teamInboxUpdated';
  public static readonly FORM_GUARD_CHANGED: string = 'formGuardChanged';
  /** Open simplified New contact dialog (ExternalNewContact standalone) from messaging, without switching apps. */
  public static readonly OPEN_ADD_CONTACT_FROM_EMAIL: string = 'openAddContactFromEmail';

  public detail?: any;

  constructor(eventName: string, detail?: any) {
    super(eventName);
    this.detail = detail;
  }
}

function subscribe(eventName: string, callback: (event: AtollonEvent) => void) {
  document.addEventListener(eventName, callback as EventListener);
}

function unsubscribe(eventName: string, callback: (event: AtollonEvent) => void) {
  document.removeEventListener(eventName, callback as EventListener);
}

function publish(eventName: string, detail?: any) {
  document.dispatchEvent(new AtollonEvent(eventName, detail));
}

export { subscribe, unsubscribe, publish, AtollonEvent };
